import { useTranslation } from 'react-i18next';
import useSWR from 'swr';
import { Chip, Grid, Tooltip } from '@mui/material';
import Typography from '@mui/material/Typography';
import RedeemIcon from '@mui/icons-material/Redeem';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../session/InternalAuthProvider';
import { AccountData, ExternalVoucherService, ExternalVoucherStatus } from '../../api';

export const PendingExternalVouchersIndicator: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { authState } = useAuth();
  const account = authState.account as unknown as AccountData;
  const externalVouchersEnabled = !!account?.external_vouchers_enabled;

  const { data, isLoading } = useSWR(
    externalVouchersEnabled ? 'externalVoucherPendingCount' : null,
    () => ExternalVoucherService.getExternalVoucherPendingCount(),
    { refreshInterval: 300000 },
  );

  if (isLoading || !data?.pending_count) {
    return null;
  }

  const handleClick = () => {
    navigate(`/dashboard/external-vouchers?status=${ExternalVoucherStatus.PENDING_VERIFICATION}`);
  };

  return (
    <Tooltip title={t('externalVouchers.pendingTooltip')} arrow>
      <Grid onClick={handleClick} sx={{ cursor: 'pointer' }}>
        <Chip
          icon={<RedeemIcon />}
          label={
            <Grid sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0.25 }}>
              <Typography variant="caption" sx={{ fontWeight: 600, lineHeight: 1.1 }}>
                {data.pending_count} {t('externalVouchers.pendingLabel')}
              </Typography>
            </Grid>
          }
          color="error"
          variant="outlined"
          size="small"
          sx={{
            height: 'auto',
            minHeight: 48,
            '& .MuiChip-label': {
              padding: '6px 8px',
            },
            '&:hover': {
              backgroundColor: 'error.light',
              color: 'error.contrastText',
            },
          }}
        />
      </Grid>
    </Tooltip>
  );
};
